module.exports = __webpack_public_path__ + "img/gift.0c496e93.svg";